import { ByocUploadContentService } from './../../service/upload-content.service';
import { ByocEpisodeService } from './../../service/episode.service';
import { Component } from '@angular/core';
import { control } from '../../../utils';

@Component({
    selector: 'app-byoc-episode-step-upload-document',
    templateUrl: './upload-document.component.html',
    styleUrls: ['./upload-document.component.scss'],
    standalone: false
})
export class ByocEpisodeStepUploadDocumentComponent {
    constructor(
        private byocEpisodeService: ByocEpisodeService,
        private uploadContentService: ByocUploadContentService,
    ) {}

    get termsAcceptControl() {
        return control(this.byocEpisodeService.form.get('hostedCustomContent')!.get('termsAccept'));
    }

    get documentControl() {
        return this.uploadContentService.fileControl;
    }

    get hasFile() {
        return this.documentControl.value?.file !== null;
    }

    get hasAcceptTerms() {
        return this.termsAcceptControl.value;
    }

    next() {
        if (this.hasAcceptTerms) {
            this.uploadContentService.uploadDocumentGoToGeneralStepFrom();
        }
    }

    cancel() {
        this.byocEpisodeService.close('btn-close');
    }
}
